export default "__VITE_ASSET__DufBef4p__"